import React, { useState, useRef, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { getAvatarColor } from "../../utils/commonUtils";
import '../table/CommonTable.scss';

const AnalystName = ({ name, values }) => {
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        const checkTruncation = () => {
            if (textRef.current) {
                setIsTextTruncated(
                    textRef.current.scrollWidth > textRef.current.clientWidth
                );
            }
        };

        checkTruncation();
        window.addEventListener('resize', checkTruncation);
        return () => window.removeEventListener('resize', checkTruncation);
    }, [name]);

    const avatar = values?.profile_picture_url ? (
        <img
            src={values?.profile_picture_url}
            alt={name}
        />
    ) : (
        name
            .split(" ")
            .map((n) => n[0])
            .slice(0, 2)
            .join("")
    );

    return (
        <div className="flex items-center">
            {values?.profile_picture_url ? (
                <div className="analyst-avatar">
                    {avatar}
                </div>
            ) : (
                <div
                    className="analyst-avatar"
                    style={{ background: getAvatarColor(name) }}
                >
                    {avatar}
                </div>
            )}

            <span
                ref={textRef}
                className="analyst-name-text truncate w-full max-w-[150px] text-left"
            >
                {isTextTruncated ? (
                    <Tooltip title={name} arrow>
                        <span>{name}</span>
                    </Tooltip>
                ) : (
                    name
                )}
            </span>
        </div>
    );
};

export default AnalystName;
